import { PasswordConstants } from "../constants/password.constants";

const PasswordReducer = (state, action) => {
  switch (action.type) {
    case PasswordConstants.FETCH_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PasswordConstants.FETCH_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        passwords: action.payload.data,
        paging: action.payload.paging,
      };
    case PasswordConstants.FETCH_PASSWORD_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PasswordConstants.PASSWORD_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PasswordConstants.PASSWORD_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        passwordSearchResults: action.payload,
      };
    case PasswordConstants.PASSWORD_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PasswordConstants.PASSWORD_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PasswordConstants.PASSWORD_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        passwordAutoSearchResults: action.payload,
      };
    case PasswordConstants.PASSWORD_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PasswordConstants.ADD_PASSWORD_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case PasswordConstants.ADD_PASSWORD_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case PasswordConstants.ADD_PASSWORD_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case PasswordConstants.GET_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case PasswordConstants.GET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        generatedPassword: action.payload,
      };
    case PasswordConstants.GET_PASSWORD_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case PasswordConstants.UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case PasswordConstants.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        password: action.payload,
      };
    case PasswordConstants.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case PasswordConstants.DOWNLOAD_PASSWORD_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case PasswordConstants.DOWNLOAD_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case PasswordConstants.DOWNLOAD_PASSWORD_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case PasswordConstants.UPLOAD_PASSWORD_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case PasswordConstants.UPLOAD_PASSWORD_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case PasswordConstants.UPLOAD_PASSWORD_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default PasswordReducer;
